module.exports = __webpack_public_path__ + "static/media/frontend.db0c9732.png";